export const Tier0ActiveCollectibles = [
    ['The Poop', '36'],
    ['Kamikaze!', '40'],
    ['Mom\'s Pad', '41'],
    ['Teleport', '44'],
    ['The Bean', '111'],
    ['Razor Blade', '126'],
    ['Portable Slot', '177'],
    ['Blood Rights', '186'],
    ['D10', '285'],
    ['Book of Secrets', '287'],
    ['The Jar', '290'],
    ['Isaac\'s Tears', '323'],
    ['Breath of Life', '326'],
    ['Broken Glass Cannon', '474'],
    ['Plan C', '475'],
    ['Dataminer', '481'],
    ['Clicker', '482'],
    ['Brown Nugget', '504'],
    ['The Scooper', '605'],
    ['Recall', '714'],
    ['Hold', '715'],
];